import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import { fragment } from 'ember-data-model-fragments/attributes';
import type Address from '@linc-technologies/linced-common/models/wonde/address';

// Proto: provider_wonde.School.
export default class School extends Model {
  declare [Type]: 'wonde/school';

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare establishmentNumber: string;

  @attr('string', { defaultValue: '' })
  declare educationPhase: string;

  @attr('string', { defaultValue: '' })
  declare sis: string;

  @fragment('wonde/address')
  declare address: Address | null;
}
